import FieldPalette from './FieldPalette.component';

export default FieldPalette;
